<template>
  <div>
    <form v-on:submit.prevent="sendEmail">
      <!-- FILTER USER (sama seperti SendWhatsapp) -->
      <label for="">User Level</label>
      <select v-model="form.user_level" class="form-control">
        <option value="all" selected>All</option>
        <option value="user">User</option>
        <option value="user-agency">User Agency</option>
        <option value="agency">Agency</option>
      </select>
      <br>
      <label for="">Paket</label>
      <select v-model="form.paket" class="form-control">
        <option value="all" selected>All</option>
        <option value="paid">Paid</option>
        <option value="trial">Trial</option>
      </select>
      <br>
      <label for="">Status</label>
      <select v-model="form.status" class="form-control">
        <option value="all" selected>All</option>
        <option value="active">Aktif</option>
        <option value="inactive">Tidak Aktif</option>
      </select>
      <br>
      <label for="">Saldo Minimal</label>
      <input type="number" v-model="form.balance" class="form-control" required>
      <br>

      <!-- SENDER OVERRIDE (optional) -->
      <div class="card" style="background:#f8f9fa">
        <div class="card-body" style="padding: 15px">
          <h6 class="mb-2"><b>Pengirim</b> <small class="text-muted">(kosongkan untuk pakai default server)</small></h6>
          <div class="row">
            <div class="col-md-6">
              <label>From Name</label>
              <input type="text" v-model="form.from_name" class="form-control" placeholder="starsender">
            </div>
            <div class="col-md-6">
              <label>From Email</label>
              <input type="email" v-model="form.from_email" class="form-control" placeholder="info@starfield.id">
              <small class="text-muted">Harus sudah terdaftar di Mailketing Domain</small>
            </div>
          </div>
        </div>
      </div>
      <br>

      <!-- SUBJECT -->
      <label for="">Subject</label>
      <input type="text" class="form-control" v-model="form.subject" required placeholder="Subject email">
      <br>

      <!-- CONTENT with tabs: Editor | Preview -->
      <label for="">Isi Pesan (Content)</label>
      <div class="nav nav-tabs mb-2" role="tablist" style="border-bottom: 2px solid #e2e8f0;">
        <a href="#" class="nav-link" :class="{ active: contentTab === 'editor' }"
          @click.prevent="contentTab = 'editor'"
          style="cursor:pointer; padding:8px 16px; margin-right:4px; border:none; border-bottom:2px solid transparent;"
          :style="contentTab === 'editor' ? { borderBottomColor: '#4f46e5', color: '#4f46e5', fontWeight: 600 } : { color: '#64748b' }">
          ✏️ Editor
        </a>
        <a href="#" class="nav-link" :class="{ active: contentTab === 'preview' }"
          @click.prevent="contentTab = 'preview'"
          style="cursor:pointer; padding:8px 16px; border:none; border-bottom:2px solid transparent;"
          :style="contentTab === 'preview' ? { borderBottomColor: '#4f46e5', color: '#4f46e5', fontWeight: 600 } : { color: '#64748b' }">
          👁️ Preview HTML
        </a>
        <div class="ml-auto d-flex align-items-center">
          <small class="text-muted">Sample: <b>{{ sampleUser.name }}</b> / {{ sampleUser.email }}</small>
        </div>
      </div>

      <!-- Editor tab -->
      <div v-show="contentTab === 'editor'">
        <textarea class="form-control" rows="14" v-model="form.content" required
          placeholder="Bisa plain text atau HTML. Contoh: <h2>Halo {nama}</h2><p>Selamat datang...</p>"
          style="font-family: 'Courier New', monospace; font-size: 13px;"></textarea>
        <small class="text-muted d-block mt-1">
          Placeholder tersedia: <code>{nama}</code>, <code>{email}</code>, <code>{username}</code>
          — otomatis diganti dengan data user penerima.
          <br>
          💡 Bisa paste HTML lengkap (dengan inline CSS) — akan di-render di email client user.
        </small>
      </div>

      <!-- Preview tab -->
      <div v-show="contentTab === 'preview'">
        <div v-if="!form.content" class="alert alert-warning text-center" style="padding: 40px;">
          Belum ada content. Ketik di tab Editor dulu ya.
        </div>
        <div v-else>
          <div class="alert alert-info mb-2" style="font-size: 12px; padding: 8px 12px;">
            ℹ️ Preview pakai sample data: <b>{{ sampleUser.name }}</b> / <b>{{ sampleUser.email }}</b> / <b>{{ sampleUser.username }}</b>.
            Saat dikirim, placeholder diganti data masing-masing user penerima.
          </div>
          <div style="border: 2px solid #e2e8f0; border-radius: 8px; overflow: hidden; background: #ffffff;">
            <!-- Email header mock (like Gmail) -->
            <div style="background: #f7fafc; padding: 12px 16px; border-bottom: 1px solid #e2e8f0; font-size: 13px;">
              <div><b>Subject:</b> {{ renderedSubject || '(belum ada subject)' }}</div>
              <div><b>From:</b> {{ form.from_name || 'starsender' }} &lt;{{ form.from_email || 'info@starfield.id' }}&gt;</div>
              <div><b>To:</b> {{ sampleUser.email }}</div>
            </div>
            <!-- Rendered body -->
            <iframe :srcdoc="renderedContent" style="width: 100%; height: 500px; border: 0; display: block;"
              sandbox="allow-same-origin"></iframe>
          </div>
          <div class="text-right mt-2">
            <button type="button" class="btn btn-sm btn-outline-secondary" @click="copyRenderedHTML">
              <i class="fas fa-copy"></i> Copy Rendered HTML
            </button>
          </div>
        </div>
      </div>
      <br>

      <!-- ATTACHMENTS (max 3) -->
      <div class="card" style="background:#f8f9fa">
        <div class="card-body" style="padding: 15px">
          <h6 class="mb-2"><b>Lampiran (URL)</b> <small class="text-muted">max 3, max 2MB per file, opsional</small></h6>
          <input type="url" v-model="form.attach1" class="form-control mb-2" placeholder="https://... (attachment 1)">
          <input type="url" v-model="form.attach2" class="form-control mb-2" placeholder="https://... (attachment 2)">
          <input type="url" v-model="form.attach3" class="form-control" placeholder="https://... (attachment 3)">
        </div>
      </div>
      <br>

      <!-- DELAY -->
      <label>Delay antar email (detik)</label>
      <div class="row">
        <div class="col-md-5">
          <input type="number" v-model.number="form.delay_start" placeholder="Dari" class="form-control" min="0">
        </div>
        <div class="col-md-2 text-center"><b>SAMPAI</b></div>
        <div class="col-md-5">
          <input type="number" v-model.number="form.delay_end" placeholder="Sampai" class="form-control" min="0">
        </div>
      </div>
      <small class="text-muted">Direkomendasikan 2-5 detik untuk menghindari rate limit Mailketing.</small>
      <br><br>

      <button class="btn btn-primary btn-block" :disabled="isSending">
        <span v-if="isSending">
          <div class="spinner-border spinner-border-sm" role="status"></div>
          Mengirim... ({{ progress.done }}/{{ progress.total }})
        </span>
        <span v-else>Kirim Email</span>
      </button>
    </form>

    <!-- PROGRESS & RESULT -->
    <div v-if="progress.total > 0" class="mt-3">
      <div class="progress" style="height: 10px">
        <div class="progress-bar"
          :style="{ width: (progress.total ? (progress.done / progress.total) * 100 : 0) + '%' }"></div>
      </div>
      <p class="mt-2">
        Progress: <b>{{ progress.done }} / {{ progress.total }}</b>
        <span class="text-success ml-2">&check; {{ progress.success }} berhasil</span>
        <span class="text-danger ml-2">&times; {{ progress.failed }} gagal</span>
      </p>
      <div v-if="failedList.length > 0" style="max-height: 250px; overflow-y: auto" class="mt-2">
        <h6>Email yang gagal:</h6>
        <ul class="small text-danger">
          <li v-for="(e, i) in failedList" :key="i">
            {{ e.email }} — {{ e.message }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        user_level: "all",
        paket: "all",
        status: "all",
        balance: 0,
        from_name: "",
        from_email: "",
        subject: "",
        content: "",
        attach1: "",
        attach2: "",
        attach3: "",
        delay_start: 2,
        delay_end: 5,
      },
      isSending: false,
      progress: { total: 0, done: 0, success: 0, failed: 0 },
      failedList: [],
      // Preview feature
      contentTab: "editor", // 'editor' | 'preview'
      sampleUser: {
        name: "Budi Santoso",
        email: "budi@example.com",
        username: "budisan",
      },
    };
  },
  computed: {
    renderedContent() {
      return this.renderPlaceholders(this.form.content, this.sampleUser);
    },
    renderedSubject() {
      return this.renderPlaceholders(this.form.subject, this.sampleUser);
    },
  },
  methods: {
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async copyRenderedHTML() {
      try {
        await navigator.clipboard.writeText(this.renderedContent);
        this.$toast.success("HTML hasil render ter-copy ke clipboard");
      } catch (e) {
        this.$toast.error("Gagal copy: " + e.message);
      }
    },
    renderPlaceholders(template, user) {
      if (!template) return "";
      return template
        .replace(/\{nama\}/g, user.name || "")
        .replace(/\{email\}/g, user.email || "")
        .replace(/\{username\}/g, user.username || "");
    },
    randomDelay() {
      const a = Math.max(0, parseInt(this.form.delay_start) || 0);
      const b = Math.max(a, parseInt(this.form.delay_end) || a);
      return Math.floor(Math.random() * (b - a + 1)) + a;
    },
    async sendEmail() {
      if (this.isSending) return;

      if (!this.form.subject || !this.form.content) {
        this.$toast.error("Subject dan Content wajib diisi");
        return;
      }

      this.isSending = true;
      this.progress = { total: 0, done: 0, success: 0, failed: 0 };
      this.failedList = [];

      try {
        // 1. Ambil daftar user sesuai filter
        this.$toast.info("Memuat daftar user sesuai filter...");
        const listRes = await this.$store.dispatch("admin_user_message_list", {
          user_level: this.form.user_level,
          paket: this.form.paket,
          status: this.form.status,
          balance: parseInt(this.form.balance) || 0,
        });
        const users = (listRes.data && listRes.data.data && listRes.data.data.users) || [];

        // Filter: only those with valid email
        const withEmail = users.filter(u => u.email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(u.email));

        if (withEmail.length === 0) {
          this.$toast.error("Tidak ada user dengan email valid sesuai filter.");
          this.isSending = false;
          return;
        }

        if (!confirm(`Akan kirim email ke ${withEmail.length} user. Lanjutkan?`)) {
          this.isSending = false;
          return;
        }

        this.progress.total = withEmail.length;

        // 2. Loop kirim per user
        for (let i = 0; i < withEmail.length; i++) {
          const user = withEmail[i];
          const payload = {
            recipient: user.email,
            subject: this.renderPlaceholders(this.form.subject, user),
            content: this.renderPlaceholders(this.form.content, user),
          };
          if (this.form.from_name) payload.from_name = this.form.from_name;
          if (this.form.from_email) payload.from_email = this.form.from_email;
          if (this.form.attach1) payload.attach1 = this.form.attach1;
          if (this.form.attach2) payload.attach2 = this.form.attach2;
          if (this.form.attach3) payload.attach3 = this.form.attach3;

          try {
            await this.$store.dispatch("admin_send_email", payload);
            this.progress.success++;
          } catch (err) {
            this.progress.failed++;
            const msg =
              (err.response && err.response.data && err.response.data.message) ||
              err.message ||
              "Unknown error";
            this.failedList.push({ email: user.email, message: msg });
          }
          this.progress.done++;

          // Delay
          if (i < withEmail.length - 1) {
            const delayMs = this.randomDelay() * 1000;
            if (delayMs > 0) await this.sleep(delayMs);
          }
        }

        if (this.progress.success > 0) {
          this.$toast.success(`${this.progress.success} email berhasil dikirim`);
        }
        if (this.progress.failed > 0) {
          this.$toast.error(`${this.progress.failed} email gagal — lihat daftar di bawah`);
        }
      } catch (err) {
        this.$toast.error(
          (err.response && err.response.data && err.response.data.message) ||
            err.message ||
            "Server error"
        );
      } finally {
        this.isSending = false;
      }
    },
  },
};
</script>

<style scoped>
code {
  background: #f1f1f1;
  padding: 1px 6px;
  border-radius: 3px;
  font-size: 12px;
  color: #d63384;
}
</style>
